module.exports = __webpack_public_path__ + "store/img/glow-tag.699e6235.jpg";